import { Counterparty } from "./counterparty";
import { FinancialAccount } from "./financialAccount";

export enum InvoiceStatus {
    DRAFT = "draft",
    OPEN = "open",
    PAID = "paid",
    VOID = "void",
    UNCOLLECTABLE = "uncollectable",
}

export enum InvoiceSource {
    MANUAL = "manual",
    STRIPE = "stripe",
}

export interface Invoice {
    id: string;
    createdAt: Date;
    updatedAt: Date;
    due: Date | null;
    paidAt: Date | null;
    total: number;
    subtotal: number;
    tax: number;
    discount: number;
    currency: string;
    counterparty?: Counterparty;
    description: string | null;
    status: InvoiceStatus;
    source: InvoiceSource;
    sourceId: string | null;
    lines?: InvoiceLineItem[];
    financialAccountId: number;
    financialAccount?: FinancialAccount;
}

export interface InvoiceLineItem {
    id: string;
    amount: number;
    unitAmount?: number | null;
    currency: string;
    description: string | null;
    quantity: number | null;
    source: InvoiceSource;
    sourceId: string;
}

export interface InvoiceSort {
    field: string;
    order: "ASC" | "DESC";
}

export enum InvoiceSortValue {
    DATE_ASC = "DATE_ASC",
    DATE_DESC = "DATE_DESC",
    DUE_DATE_ASC = "DUE_DATE_ASC",
    DUE_DATE_DESC = "DUE_DATE_DESC",
    STATUS_ASC = "STATUS_ASC",
    STATUS_DESC = "STATUS_DESC",
    COUNTERPARTY_ASC = "COUNTERPARTY_ASC",
    COUNTERPARTY_DESC = "COUNTERPARTY_DESC",
    ACCOUNT_ASC = "ACCOUNT_ASC",
    ACCOUNT_DESC = "ACCOUNT_DESC",
    AMOUNT_ASC = "AMOUNT_ASC",
    AMOUNT_DESC = "AMOUNT_DESC",
    NONE = "NONE",
}

export enum InvoiceByCounterpartySortValue {
    COUNTERPARTY_ASC = "COUNTERPARTY_ASC",
    COUNTERPARTY_DESC = "COUNTERPARTY_DESC",
    NOT_YET_DUE_ASC = "NOT_YET_DUE_ASC",
    NOT_YET_DUE_DESC = "NOT_YET_DUE_DESC",
    PAST_DUE_1_30_ASC = "PAST_DUE_1_30_ASC",
    PAST_DUE_1_30_DESC = "PAST_DUE_1_30_DESC",
    PAST_DUE_31_60_ASC = "PAST_DUE_31_60_ASC",
    PAST_DUE_31_60_DESC = "PAST_DUE_31_60_DESC",
    PAST_DUE_61_PLUS_ASC = "PAST_DUE_61_PLUS_ASC",
    PAST_DUE_61_PLUS_DESC = "PAST_DUE_61_PLUS_DESC",
    OPEN_ASC = "OPEN_ASC",
    OPEN_DESC = "OPEN_DESC",
    PAID_ASC = "PAID_ASC",
    PAID_DESC = "PAID_DESC",
    INVOICES_COUNT_ASC = "INVOICES_COUNT_ASC",
    INVOICES_COUNT_DESC = "INVOICES_COUNT_DESC",
}

export enum InvoiceDueDateSubsegment {
    NOT_YET_DUE = "not_yet_due",
    PAST_DUE_1_TO_30 = "past_due_1_to_30",
    PAST_DUE_31_TO_60 = "past_due_31_to_60",
    PAST_DUE_61_PLUS = "past_due_61_plus",
}

export const InvoiceDueDateLabels = {
    [InvoiceDueDateSubsegment.NOT_YET_DUE]: "Not due yet",
    [InvoiceDueDateSubsegment.PAST_DUE_1_TO_30]: "1-30d",
    [InvoiceDueDateSubsegment.PAST_DUE_31_TO_60]: "31-60d",
    [InvoiceDueDateSubsegment.PAST_DUE_61_PLUS]: "61d+",
};

export enum InvoiceViewOptionGroup {
    INVOICE = "invoice",
    COUNTERPARTY = "counterparty",
}

export interface InvoiceViewOptions {
    groupBy: InvoiceViewOptionGroup;
}

export interface InvoiceStatEntity {
    id: number;
    count: number;
    total: number;
}

export interface InvoiceStatSubsegment {
    label: InvoiceDueDateSubsegment;
    count: number;
    total: number;
    entities?: InvoiceStatEntity[];
}

export interface InvoiceStat {
    count: number;
    total: number;
    subsegments?: InvoiceStatSubsegment[];
}

export interface InvoiceStats {
    draft: InvoiceStat;
    open: InvoiceStat;
    paid: InvoiceStat;
    void: InvoiceStat;
    uncollectable: InvoiceStat;
}

export interface InvoicesByCounterpartyItem {
    counterpartyId: string;
    counterparty?: Counterparty;
    open: number;
    paid: number;
    notYetDue: number;
    pastDue1To30: number;
    pastDue31To60: number;
    pastDue61Plus: number;
    invoiceCount: number;
    totalCounterparties: number;
    entityIds: number[];
}
